import React, { useState } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

import { translate } from '@vestahealthcare/common/i18n';

import { IconButton } from '../IconButton';
import { Tooltip } from '../Tooltip';

type Props = {
  className?: string;
  copiedLabel?: string;
  copyLabel?: string;
  value?: string;
  size?: SvgIconTypeMap['props']['fontSize'];
};

export const CopyIcon = ({
  className,
  copiedLabel,
  copyLabel,
  value,
  size,
}: Props) => {
  const [copied, setCopied] = useState<boolean>(false);

  const cophyPhone = (evt: React.MouseEvent<Element, MouseEvent>) => {
    evt.stopPropagation();
    evt.preventDefault();
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
    }
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <IconButton
      className={className}
      onClick={(evt) => cophyPhone(evt)}
      size="small"
    >
      <Tooltip
        text={
          copied
            ? copiedLabel || translate('components.CopyIcon.copied')
            : copyLabel || translate('components.CopyIcon.copy')
        }
      >
        <ContentCopyIcon color="info" fontSize={size} />
      </Tooltip>
    </IconButton>
  );
};
